import { render, staticRenderFns } from "./SectionWhySalem.vue?vue&type=template&id=c3f273a8&scoped=true"
import script from "./SectionWhySalem.vue?vue&type=script&lang=ts"
export * from "./SectionWhySalem.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhySalem.vue?vue&type=style&index=0&id=c3f273a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f273a8",
  null
  
)

export default component.exports